import { create } from 'zustand';

import { ClipSelection } from '../types';

interface VideoBuilderStore {
  clipSelections: ClipSelection[];
  deletingClipsIds: string[];

  setClipSelections: (clipSelections: ClipSelection[]) => void;
  updateDeletingClipsIds: (elementId: string, isAdd?: boolean) => void;
}

export const useVideoBuilderStore = create<VideoBuilderStore>((set, get) => ({
  clipSelections: [],
  deletingClipsIds: [],

  setClipSelections: (clipSelections) => {
    set((state) => ({ ...state, clipSelections }));
  },

  updateDeletingClipsIds: (elementId: string, isAdd?: boolean) => {
    let deletingClipsIds = [...get().deletingClipsIds];
    if (isAdd) deletingClipsIds.push(elementId);
    else deletingClipsIds = deletingClipsIds.filter((id) => id !== elementId);

    set((state) => ({ ...state, deletingClipsIds }));
  },
}));
